<template>
    <ul class="cell_info_detail">
        <li class="top">
            <span class="time">{{ time }}</span>
            <span class="mgl_auto">
                <button class="btn btn_xs ico btn_white" @click="action_Update()"><v-icon>mdi-pencil</v-icon></button>
                <button class="btn btn_xs ico btn_white" @click="action_Remove()"><v-icon>mdi-trash-can-outline</v-icon></button>
            </span>
        </li>
        <li class="bottom">
            <v-icon v-if="isBlockItem">mdi-cancel</v-icon>
            <span class="color_circle" v-if="!isBlockItem" :style="backgroundStyle"></span>
            <span class="memo">{{ note }}</span>
        </li>
    </ul>
</template>
<script>
import moment from '@/util/MPMoment'
import { sheetState } from '../../../../sheet-state'
import { sheetAxis } from '../../../../sheet-axis'

export default {
    props: {
        value: Object
    },
    data() {
        return {
            sheetState,
            sheetAxis,
        }
    },
    watch: {},
    computed: {
        palette: function () {
            return this.sheetState.reservationSetting?.cellColorPaletteID?.basicPalette
        },
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        dayOfWeek: function () {
            return moment(this.selectedDate).format('dddd')
        },
        weekOfMonth: function () {
            let dayOfMonth = moment(this.selectedDate).date()
            return Math.ceil(dayOfMonth / 7)
        },
        weekOfMonthString: function () {
            let weeks = [ '첫', '두', '세', '네' ]
            let index = this.isWeekFive ? 2 : 1
            return weeks[this.weekOfMonth - index]
        },
        time: function () {
            let s = moment(this.value.startedAt).format('HH:mm')
            let e = moment(this.value.endedAt).format('HH:mm')
            return `${ s } ~ ${ e }`
        },
        backgroundStyle: function () {
            let data = this.value
            if (data.cellType == 'block') return ''
            let color = data.usingCustomColor ? data.customColorCode : this.palette[data.paletteIndex]
            return `background-color: ${ color };`
        },
        isBlockItem: function () {
            return this.value.cellType == 'block'
        },
        note: function () {
            let note = this.value.note ?? ''
            let option = this.isBlockItem ? this.getParsedRoutineTypeString(this.value) : ''
            return `${ option } ${ note }`
        },
    },
    methods: {
        // MARK: - Private
        getParsedRoutineTypeString(block) {
            switch (block.routineTimeUnit) {
                case 'daily': {
                    return '[매일]'
                }
                case 'weekly': {
                    let weekDays = block.routineWeekDays
                    if (weekDays.length == 1) return `[매주 ${ this.dayOfWeek }]`
                    if (weekDays.length == 5) return '[매주 월~금]'
                    else return `[매주 월~토]`
                }
                case 'monthly': {
                    if (block.routineWeekOfMonth != 'last') return `매월 ${ this.weekOfMonthString } 번째 ${ this.dayOfWeek }` // 3
                    else return `[매월 마지막 ${ this.dayOfWeek }]`
                }
                default:
                    return ''
            }
        },
        // MARK: - Action
        action_Update() {
            this.$emit('updateItem', this.value)
        },
        action_Remove() {
            this.$emit('removeItem', this.value)
        }
    }
}

</script>